/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="113.06"
        height="94.33"
        viewBox="0 0 113.06 94.33"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M50.1 0h-.45a7.8 7.8 0 0 0-7.78 7.78V8a7.7 7.7 0 0 0 2.57 5.78L54 23.57a1.25 1.25 0 0 0 1.76 0l.93-.93 8.61-8.84A7.77 7.77 0 0 0 67.87 8v-.24A7.79 7.79 0 0 0 60.09 0h-.76a7.6 7.6 0 0 0-4.26 1.47l-.22.19-.21-.16A7.73 7.73 0 0 0 50.1 0Zm-.44 2.5h.44a5.22 5.22 0 0 1 3.74 1.55l.16.16a1.27 1.27 0 0 0 1.76 0l.16-.16a5.2 5.2 0 0 1 3.74-1.55h.45a5.28 5.28 0 0 1 5.28 5.28v.21a5.28 5.28 0 0 1-1.8 4l-8.69 8.92-8.73-8.92a5.28 5.28 0 0 1-1.8-4v-.24a5.29 5.29 0 0 1 5.29-5.25Z"
          className="icon-fill icon-accent"/>
        <path
          fill="none"
          d="M17.23 83.79v10.54"/>
        <path
          fill="#fff"
          d="M18.48 83.79v10.54h-2.5V83.79Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M17.24 63.33v20.46"/>
        <path
          fill="#fff"
          d="M17.24 62.08a1.25 1.25 0 0 1 1.24 1.12v20.59A1.25 1.25 0 0 1 17.19 85a1.24 1.24 0 0 1-1.2-1.09V63.33a1.23 1.23 0 0 1 1.23-1.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M8.53 83.79v10.54"/>
        <path
          fill="#fff"
          d="M9.78 83.79v10.54h-2.5V83.79Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M8.53 43.59v40.2"/>
        <path
          fill="#fff"
          d="M8.53 42.34a1.27 1.27 0 0 1 1.25 1.13v40.32A1.25 1.25 0 0 1 8.49 85a1.24 1.24 0 0 1-1.2-1.09V43.59a1.24 1.24 0 0 1 1.24-1.25ZM17.23 7a9.19 9.19 0 1 0 9.19 9.19 9.18 9.18 0 0 0-9.18-9.18Zm0 2.5a6.69 6.69 0 1 1-6.68 6.7 6.68 6.68 0 0 1 6.63-6.73Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M25.93 83.79v10.54"/>
        <path
          fill="#fff"
          d="M27.18 83.79v10.54h-2.5V83.79Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M25.93 43.59v40.2"/>
        <path
          fill="#fff"
          d="M25.93 42.34a1.27 1.27 0 0 1 1.25 1.13v40.32A1.25 1.25 0 0 1 25.89 85a1.24 1.24 0 0 1-1.2-1.09V43.59a1.24 1.24 0 0 1 1.24-1.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M23.85 28.07a10.64 10.64 0 0 1 10.63 10.36v22.71a3.71 3.71 0 0 1-3.46 3.49h-5a1.26 1.26 0 0 1-1.22-1.29 1.25 1.25 0 0 1 1.1-1.2h5a1.19 1.19 0 0 0 1.12-1.08V38.71a8.15 8.15 0 0 0-7.9-8.14H10.64a8.13 8.13 0 0 0-8.13 7.89v22.48a1.19 1.19 0 0 0 1.07 1.19h5a1.24 1.24 0 0 1 1.31 1.18 1.25 1.25 0 0 1-1.18 1.32h-5A3.69 3.69 0 0 1 0 61.14V38.71a10.63 10.63 0 0 1 10.36-10.64Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M92.21 74.66v19.63"/>
        <path
          fill="#fff"
          d="M93.46 74.66v19.63h-2.5V74.66Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M100.91 74.66v19.63"/>
        <path
          fill="#fff"
          d="M102.16 74.66v19.63h-2.5V74.66ZM106.37 34.57a1.26 1.26 0 0 1 1.45.83v.13l5.19 23.59v.19a3.7 3.7 0 0 1-2.66 4.17h-.19l-4.73 1a1.26 1.26 0 0 1-1.45-1 1.23 1.23 0 0 1 .79-1.38h.13l4.72-1a1.2 1.2 0 0 0 .93-1.3v-.14l-5.2-23.58a1.25 1.25 0 0 1 .83-1.45Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M83.51 74.66v19.63"/>
        <path
          fill="#fff"
          d="M84.76 74.66v19.63h-2.5V74.66ZM92.21 7a9.19 9.19 0 1 0 9.19 9.19A9.19 9.19 0 0 0 92.21 7Zm0 2.5a6.69 6.69 0 1 1-6.69 6.69 6.68 6.68 0 0 1 6.65-6.73Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M100.91 74.66v19.63"/>
        <path
          fill="#fff"
          d="M102.16 74.66v19.63h-2.5V74.66Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M100.63 42.37a1.25 1.25 0 0 1 1.46.83v.13l6.84 31.1a1.24 1.24 0 0 1-.94 1.48H76.68a1.25 1.25 0 0 1-1.25-1.25.76.76 0 0 1 0-.15v-.12l6.84-31.1a1.25 1.25 0 0 1 2.46.41v.12l-6.51 29.59h28l-6.51-29.59a1.24 1.24 0 0 1 .83-1.45Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M76.57 35.53a1.25 1.25 0 0 1 2.46.41v.12l-5.18 23.6a1.2 1.2 0 0 0 .79 1.39h.12l4.72 1a1.25 1.25 0 0 1-.41 2.46h-.12l-4.73-1a3.68 3.68 0 0 1-2.85-4.21v-.19Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M98.85 28.07a9.22 9.22 0 0 1 9 7.49 1.25 1.25 0 0 1-.9 1.52 1.23 1.23 0 0 1-1.52-.89.5.5 0 0 1 0-.16 6.74 6.74 0 0 0-6.36-5.46H85.62A6.72 6.72 0 0 0 79 36a1.25 1.25 0 0 1-2.48-.31.41.41 0 0 1 0-.16 9.22 9.22 0 0 1 8.79-7.49h13.54ZM52.85 76.28a1.27 1.27 0 0 1 1.25 1.13v14.76a1.25 1.25 0 0 1-2.49.13V77.53a1.24 1.24 0 0 1 1.24-1.25ZM46.35 62.4a1.25 1.25 0 0 1 1.24 1.13v28.64a1.25 1.25 0 0 1-2.49.13V63.66a1.25 1.25 0 0 1 1.25-1.26Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M52.85 76.28a1.27 1.27 0 0 1 1.25 1.13v14.76a1.25 1.25 0 0 1-2.49.13V77.53a1.24 1.24 0 0 1 1.24-1.25ZM59.4 62.4a1.25 1.25 0 0 1 1.24 1.13v28.64a1.25 1.25 0 0 1-2.49.13V63.66a1.25 1.25 0 0 1 1.25-1.26Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M52.85 76.28a1.27 1.27 0 0 1 1.25 1.13v14.76a1.25 1.25 0 0 1-2.49.13V77.53a1.24 1.24 0 0 1 1.24-1.25ZM47.6 65.82v28.51h-2.5V65.82Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M54.12 79.66v14.63h-2.5V79.66ZM60.65 65.82v28.51h-2.5V65.82Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M59 53.4a7.25 7.25 0 0 1 7.25 7v12.26a1.26 1.26 0 0 1-1.13 1.24H59.4a1.27 1.27 0 0 1-1.23-1.28 1.25 1.25 0 0 1 1.1-1.21h4.51V60.66a4.74 4.74 0 0 0-4.54-4.74H46.73A4.74 4.74 0 0 0 42 60.45v11h4.38a1.24 1.24 0 0 1 1.24 1.12v.09a1.25 1.25 0 0 1-1.12 1.24h-5.78a1.25 1.25 0 0 1-1.24-1.12V60.66a7.25 7.25 0 0 1 7-7.25ZM52.85 36.2a7.23 7.23 0 1 0 7.23 7.23 7.22 7.22 0 0 0-7.22-7.22Zm0 2.5a4.73 4.73 0 1 1-4.72 4.74 4.72 4.72 0 0 1 4.72-4.78Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'FamilyHeartIcon';

export default Icon;
